import { render } from "./DataTableInfiniteScroll.vue?vue&type=template&id=93482188"
import script from "./DataTableInfiniteScroll.vue?vue&type=script&lang=js"
export * from "./DataTableInfiniteScroll.vue?vue&type=script&lang=js"

import "./DataTableInfiniteScroll.vue?vue&type=style&index=0&id=93482188&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__